import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
export default new Router({
    // mode: 'history',
    routes: [{
        path: '/',
        component: resolve => require(['../components/views/base_login.vue'], resolve)
    },
        {
            path: '/lead',
            component: resolve => require(['../components/views/lead.vue'], resolve)
        },
        {
            path: '/rotaryBoard',
            component: resolve => require(['../components/rotary/board.vue'], resolve)
        },
        {
            path: '/wx',
            component: resolve => require([`../components/views/wx_login.vue`], resolve)
        },
        {
            path: '/fence',
            component: resolve => require(['../components/fence.vue'], resolve)
        },
        {
            path: '/third-login',
            component: resolve => require(['../components/views/third-login.vue'], resolve)
        },
        {
            path: '/sgitg-login',
            component: resolve => require(['../components/views/sgitg-login.vue'], resolve)
        },
        //数据看板
        {
            path: '/',
            component: resolve => require(['../components/board/boardTab.vue'], resolve),
            meta: {
                title: '数据看板'
            },
            children: [{
                path: 'board/project',
                component: resolve => require(['../components/board/project.vue'], resolve),
                meta: {
                    title: '数据看板'
                }
            },
                {
                    path: 'board/company',
                    component: resolve => require(['../components/board/company.vue'], resolve),
                    meta: {
                        title: '数据看板(企业)'
                    }
                },
                {
                    path: '/board/mach',
                    component: resolve => require(['../components/board/mach.vue'], resolve),
                    meta: {
                        title: '数据看板'
                    }
                },
                {
                    path: '/board/emp',
                    component: resolve => require(['../components/board/emp.vue'], resolve),
                    meta: {
                        title: '数据看板'
                    }
                },
                {
                    path: '/board/fse/crane',
                    component: resolve => require(['../components/board/fse_crane.vue'], resolve),
                    meta: {
                        title: '数据看板'
                    }
                },
                {
                    path: '/board/fse/lift',
                    component: resolve => require(['../components/board/fse_lift.vue'], resolve),
                    meta: {
                        title: '数据看板'
                    }
                },
                {
                    path: '/board/tunnel-gantry',
                    component: resolve => require(['../components/board/tunnel-gantry.vue'], resolve),
                    meta: {
                        title: '数据看板'
                    }
                },
                {
                    path: '/board/tunnel-bridge',
                    component: resolve => require(['../components/board/tunnel-bridge.vue'], resolve),
                    meta: {
                        title: '数据看板'
                    }
                },
                {
                    path: '/board/env',
                    component: resolve => require(['../components/board/env.vue'], resolve),
                    meta: {
                        title: '数据看板'
                    }
                },
                {
                    path: '/board/fim',
                    component: resolve => require(['../components/board/fim.vue'], resolve),
                    meta: {
                        title: '数据看板'
                    }
                },
                {
                    path: '/board/energy',
                    component: resolve => require(['../components/board/energy.vue'], resolve),
                    meta: {
                        title: '数据看板'
                    }
                },
                //中铁七局九工区
                {
                    path: '/board/shield',
                    component: resolve => require(['../components/board/shield.vue'], resolve),
                    meta: {
                        title: '盾构概况'
                    }
                },
                {
                    path: '/board/shield-data',
                    component: resolve => require(['../components/board/shield-data.vue'], resolve),
                    meta: {
                        title: '盾构项目概况'
                    }
                },
                {
                    path: '/board/shield-realtime',
                    component: resolve => require(['../components/board/shield-realtime.vue'], resolve),
                    meta: {
                        title: '盾构实时数据'
                    }
                },
                {
                    path: '/board/shield-risk',
                    component: resolve => require(['../components/board/shield-risk.vue'], resolve),
                    meta: {
                        title: '盾构风险源'
                    }
                },
                //甘肃天水
                {
                    path: '/board/gsts-env',
                    component: resolve => require(['../components/board/gsts-env.vue'], resolve),
                    meta: {
                        title: '数据看板'
                    }
                },
                {
                    path: '/board/gsts-env',
                    component: resolve => require(['../components/board/gsts-env.vue'], resolve),
                    meta: {
                        title: '数据看板'
                    }
                },
                {
                    path: '/board/gsts-fim',
                    component: resolve => require(['../components/board/gsts-fim.vue'], resolve),
                    meta: {
                        title: '数据看板'
                    }
                },
                {
                    path: '/board/gsts-mach',
                    component: resolve => require(['../components/board/gsts-mach.vue'], resolve),
                    meta: {
                        title: '数据看板'
                    }
                },
                {
                    path: '/board/sence',
                    component: resolve => require(['../components/board/sence.vue'], resolve),
                    meta: {
                        title: '数据看板'
                    }
                },
                {
                    path: '/board/tunnel-data',
                    component: resolve => require(['../components/board/tunnel-data.vue'], resolve),
                    meta: {
                        title: '数据看板'
                    }
                },
                {
                    path: '/board/tunnel-monitoring',
                    component: resolve => require(['../components/board/tunnel-monitoring.vue'], resolve),
                    meta: {
                        title: '数据看板'
                    }
                },
                {
                    path: '/board/tunnel-experiment',
                    component: resolve => require(['../components/board/tunnel-experiment.vue'], resolve),
                    meta: {
                        title: '数据看板'
                    }
                },
                {
                    path: '/board/tunnel-laboratory',
                    component: resolve => require(['../components/board/tunnel-laboratory.vue'], resolve),
                    meta: {
                        title: '数据看板'
                    }
                },
                {
                    path: '/board/tunnel-quality',
                    component: resolve => require(['../components/board/tunnel-quality.vue'], resolve),
                    meta: {
                        title: '数据看板'
                    }
                },
                {
                    path: '/board/tunnel-safety',
                    component: resolve => require(['../components/board/tunnel-safety.vue'], resolve),
                    meta: {
                        title: '数据看板'
                    }
                },
                {
                    path: '/board/ztsj-project',
                    component: resolve => require(['../components/board/ztsj-project.vue'], resolve),
                    meta: {
                        title: '数据看板'
                    }
                },
                {
                    path: '/board/ztsj-pipe',
                    component: resolve => require(['../components/board/ztsj-pipe.vue'], resolve),
                    meta: {
                        title: '进度管理'
                    }
                },
            ]
        },
        // 国网电商
        {
            path: '/sgitg/board',
            component: resolve => require(['../components//sgitg/board.vue'], resolve)
        },
        {
            path: '/sgitg/warn/list',
            component: resolve => require(['../components/sgitg/warn_list.vue'], resolve)
        },
        //消息中心
        {
            path: '/',
            component: resolve => require(['../components/msg/header.vue'], resolve),
            meta: {
                title: '消息中心'
            },
            children: [{
                path: 'msg/all',
                component: resolve => require(['../components/msg/all.vue'], resolve),
                meta: {
                    title: '全部消息'
                }
            },
                {
                    path: 'msg/unread',
                    component: resolve => require(['../components/msg/unread.vue'], resolve),
                    meta: {
                        title: '未读消息'
                    }
                },
                {
                    path: 'msg/read',
                    component: resolve => require(['../components/msg/read.vue'], resolve),
                    meta: {
                        title: '已读消息'
                    }
                },
            ]
        },
        //系统设置
        {
            path: '/',
            component: resolve => require(['../components/system_setting/header.vue'], resolve),
            meta: {
                title: '系统设置'
            },
            children: [{
                path: 'sys/user',
                component: resolve => require(['../components/system_setting/user.vue'], resolve),
                meta: {
                    title: '账号管理'
                }
            },
                {
                    path: 'sys/role',
                    component: resolve => require(['../components/system_setting/role.vue'], resolve),
                    meta: {
                        title: '角色管理'
                    }
                },
                {
                    path: 'sys/dept',
                    component: resolve => require(['../components/system_setting/dept.vue'], resolve),
                    meta: {
                        title: '组织机构'
                    }
                },
                {
                    path: 'sys/dict',
                    component: resolve => require(['../components/system_setting/dict.vue'], resolve),
                    meta: {
                        title: '数据字典'
                    }
                },
                // {
                //     path: 'sys/machType',
                //     component: resolve => require(['../components/system_setting/mach_type.vue'], resolve),
                //     meta: {
                //         title: '设备类型'
                //     }
                // },
                {
                    path: 'sys/rule',
                    component: resolve => require(['../components/system_setting/rule.vue'], resolve),
                    meta: {
                        title: '权限设置'
                    }
                },
                {
                    path: 'sys/innerAccount',
                    component: resolve => require(['../components/system_setting/InnerAccount.vue'], resolve),
                    meta: {
                        title: '内部账号'
                    }
                },
                {
                    path: 'sys/wxUser',
                    component: resolve => require(['../components/system_setting/wxUser.vue'], resolve),
                    meta: {
                        title: '微信用户'
                    }
                },
                {
                    path: 'sys/machType',
                    component: resolve => require(['../components/system_setting/machType.vue'], resolve),
                    meta: {
                        title: '设备类型'
                    }
                },
                {
                    path: 'sys/algType',
                    component: resolve => require(['../components/system_setting/algType.vue'], resolve),
                    meta: {
                        title: '算法类型'
                    }
                },
                {
                    path: 'sys/algConfig',
                    component: resolve => require(['../components/system_setting/algConfig.vue'], resolve),
                    meta: {
                        title: '算法配置'
                    }
                },
                {
                    path: 'sys/skin',
                    component: resolve => require(['../components/system_setting/skin.vue'], resolve),
                    meta: {
                        title: '皮肤定制'
                    }
                },
            ]
        },
        //项目管理
        {
            path: '/',
            component: resolve => require(['../components/project/header.vue'], resolve),
            meta: {
                title: '项目管理'
            },
            children: [{
                path: 'prj/list',
                component: resolve => require(['../components/project/index.vue'], resolve),
                meta: {
                    title: '项目信息'
                }
            },
                {
                    path: 'prj/corp',
                    component: resolve => require(['../components/project/corp.vue'], resolve),
                    meta: {
                        title: '合作单位'
                    }
                },
                {
                    path: 'prj/realName',
                    component: resolve => require(['../components/project/realName.vue'], resolve),
                    meta: {
                        title: '人员实名制'
                    }
                },
                {
                    path: 'prj/weather',
                    component: resolve => require(['../components/project/weather.vue'], resolve),
                    meta: {
                        title: '历史天气'
                    }
                },
                {
                    path: 'prj/sence',
                    component: resolve => require(['../components/project/sence.vue'], resolve),
                    meta: {
                        title: '现场模拟'
                    }
                },
                {
                    path: 'prj/log',
                    component: resolve => require(['../components/project/log.vue'], resolve),
                    meta: {title: '施工日志'}
                },
                {
                    path: 'prj/area',
                    component: resolve => require(['../components/project/workArea.vue'], resolve),
                    meta: {title: '项目工区'}
                },
                {
                    path: 'prj/report',
                    component: resolve => require(['../components/project/report.vue'], resolve),
                    meta: {title: '施工日报'}
                },
            ]
        },
        //进度管理
        {
            path: '/',
            component: resolve => require(['../components/fsdm/header.vue'], resolve),
            meta: {
                title: '进度管理'
            },
            children: [{
                path: 'fsdm/plan',
                component: resolve => require(['../components/fsdm/plan.vue'], resolve),
                meta: {
                    title: '进度计划'
                }
            },
                {
                    path: 'fsdm/wbs',
                    component: resolve => require(['../components/fsdm/wbs.vue'], resolve),
                    meta: {
                        title: 'wbs管理'
                    }
                },
                {
                    path: 'fsdm/milestone',
                    component: resolve => require(['../components/fsdm/milestone.vue'], resolve),
                    meta: {
                        title: '里程碑管理'
                    }
                },
                {
                    path: 'fsdm/plan/resource',
                    component: resolve => require(['../components/fsdm/plan_resource.vue'], resolve),
                    meta: {
                        title: '资源统计'
                    }
                },
                {
                    path: 'fsdm/quantity',
                    component: resolve => require(['../components/fsdm/quantity.vue'], resolve),
                    meta: {
                        title: '工程量统计'
                    }
                },
                {
                    path: 'fsdm/myTask',
                    component: resolve => require(['../components/fsdm/myTask.vue'], resolve),
                    meta: {
                        title: '我的任务'
                    }
                },
                {
                    path: 'fsdm/resource',
                    component: resolve => require(['../components/fsdm/resource.vue'], resolve),
                    meta: {
                        title: '资源管理'
                    }
                },
                {
                    path: 'fsdm/sys',
                    component: resolve => require(['../components/fsdm/sys.vue'], resolve),
                    meta: {
                        title: '配置中心'
                    }
                },
            ]
        },
        //文档管理
        {
            path: '/',
            component: resolve => require(['../components/doc/header.vue'], resolve),
            meta: {
                title: '文档管理'
            },
            children: [
                {
                    path: 'doc/list',
                    component: resolve => require(['../components/doc/list.vue'], resolve),
                    meta: {
                        title: '文档资料'
                    }
                },
                {
                    path: 'doc/approval',
                    component: resolve => require(['../components/doc/approval.vue'], resolve),
                    meta: {
                        title: '文档审批'
                    }
                },
                {
                    path: 'doc/components/add',
                    component: resolve => require(['../components/doc/components/add.vue'], resolve),
                    meta: {
                        title: '添加'
                    }
                },
                {
                    path: 'doc/components/edit',
                    component: resolve => require(['../components/doc/components/edit.vue'], resolve),
                    meta: {
                        title: '编辑'
                    }
                },

            ]
        },
        //质量管理
        {
            path: '/',
            component: resolve => require(['../components/quality/header.vue'], resolve),
            meta: {
                title: '质量管理'
            },
            children: [{
                path: 'quality/check',
                component: resolve => require(['../components/quality/check.vue'], resolve),
                meta: {
                    title: '检查部位'
                }
            },
                {
                    path: 'quality/problem',
                    component: resolve => require(['../components/quality/problem.vue'], resolve),
                    meta: {
                        title: '质量问题库'
                    }
                },
                {
                    path: 'quality/record',
                    component: resolve => require(['../components/quality/record.vue'], resolve),
                    meta: {
                        title: '检查记录'
                    }
                },
                {
                    path: 'quality/ana',
                    component: resolve => require(['../components/quality/ana.vue'], resolve),
                    meta: {
                        title: '统计分析'
                    }
                },
                {
                    path: 'quality/checkTask',
                    component: resolve => require(['../components/quality/checkTask.vue'], resolve),
                    meta: {
                        title: '检查任务'
                    }
                },
                {
                    path: 'quality/task',
                    component: resolve => require(['../components/quality/task.vue'], resolve),
                    meta: {
                        title: '我的任务'
                    }
                },
                {
                    path: 'quality/taskAdd',
                    component: resolve => require(['../components/quality/taskAdd.vue'], resolve),
                    meta: {
                        title: '添加任务'
                    }
                },
                {
                    path: 'quality/taskDetails',
                    component: resolve => require(['../components/quality/taskDetails.vue'], resolve),
                    meta: {
                        title: '任务详情'
                    }
                },
                {
                    path: 'quality/fine',
                    component: resolve => require(['../components/quality/fine.vue'], resolve),
                    meta: {
                        title: '罚款单'
                    }
                },
                {
                    path: 'quality/rectify',
                    component: resolve => require(['../components/quality/rectify.vue'], resolve),
                    meta: {
                        title: '整改通知单'
                    }
                },
                {
                    path: 'quality/rectifyData',
                    component: resolve => require(['../components/quality/rectifyData.vue'], resolve),
                    meta: {
                        title: '整改通知单详情'
                    }
                },
            ]
        },
        //安全管理
        {
            path: '/safety/',
            component: resolve => require(['../components/safety/header.vue'], resolve),
            meta: {
                title: '安全管理'
            },
            children: [{
                path: 'check',
                component: resolve => require(['../components/safety/check.vue'], resolve),
                meta: {
                    title: '检查部位'
                }
            },
                {
                    path: 'problem',
                    component: resolve => require(['../components/safety/problem.vue'], resolve),
                    meta: {
                        title: '安全问题库'
                    }
                },
                {
                    path: 'record',
                    component: resolve => require(['../components/safety/record.vue'], resolve),
                    meta: {
                        title: '检查记录'
                    }
                },
                {
                    path: 'ana',
                    component: resolve => require(['../components/safety/ana.vue'], resolve),
                    meta: {
                        title: '统计分析'
                    }
                },
                {
                    path: 'fine',
                    component: resolve => require(['../components/safety/fine.vue'], resolve),
                    meta: {
                        title: '罚款单'
                    }
                },
                {
                    path: 'dutyArea',
                    component: resolve => require(['../components/safety/dutyArea.vue'], resolve),
                    meta: {
                        title: '罚款单'
                    }
                },
                {
                    path: 'danger',
                    component: resolve => require(['../components/safety/danger.vue'], resolve),
                    meta: {
                        title: '罚款单'
                    }
                },
                {
                    path: 'rectify',
                    component: resolve => require(['../components/safety/rectify.vue'], resolve),
                    meta: {
                        title: '整改通知单'
                    }
                },
                {
                    path: 'rectifyData',
                    component: resolve => require(['../components/safety/rectifyData.vue'], resolve),
                    meta: {
                        title: '整改通知单详情'
                    }
                },
            ]
        },
        //导出记录
        {
            path: '/exp/',
            component: resolve => require(['../components/exp/header.vue'], resolve),
            meta: {
                title: '导出记录'
            },
            children: [{
                path: 'list',
                component: resolve => require(['../components/exp/list.vue'], resolve),
                meta: {
                    title: '导出记录'
                }
            },

            ]
        },
        //环境管理
        {
            path: '/',
            component: resolve => require(['../components/env/header.vue'], resolve),
            meta: {
                title: '环境管理'
            },
            children: [
                // {
                //     path: 'ana/env',
                //     component: resolve => require(['../components/ana/env.vue'], resolve),
                //     meta: {
                //         title: '环境分析'
                //     }
                // },
                {
                    path: 'env/device',
                    component: resolve => require(['../components/env/device.vue'], resolve),
                    meta: {
                        title: '环境设备'
                    }
                },
                {
                    path: 'env/dust/data',
                    component: resolve => require(['../components/env/dust_data.vue'], resolve),
                    meta: {
                        title: '扬尘数据'
                    }
                },
                {
                    path: 'env/dust/history',
                    component: resolve => require(['../components/env/dust_history.vue'], resolve),
                    meta: {
                        title: '历史数据'
                    }
                },
                {
                    path: 'env/dust/record',
                    component: resolve => require(['../components/env/dust_record.vue'], resolve),
                    meta: {
                        title: '报警记录(扬尘监测)'
                    }
                },
                {
                    path: 'env/dust/setting',
                    component: resolve => require(['../components/env/dust_setting.vue'], resolve),
                    meta: {
                        title: '报警设置(扬尘监测)'
                    }
                },
                // {
                //     path: 'env/warn/setting',
                //     component: resolve => require(['../components/env/warn_setting.vue'], resolve),
                //     meta: {
                //         title: '报警设置'
                //     }
                // },
                // {
                //     path: 'env/warn/record',
                //     component: resolve => require(['../components/env/warn_record.vue'], resolve),
                //     meta: {
                //         title: '报警记录'
                //     }
                // },

                {
                    path: 'env/water/data',
                    component: resolve => require(['../components/env/water_data.vue'], resolve),
                    meta: {
                        title: '水质数据'
                    }
                },
                {
                    path: 'env/gas/data',
                    component: resolve => require(['../components/env/gas_data.vue'], resolve),
                    meta: {
                        title: '毒害气体数据'
                    }
                },
                {
                    path: 'env/gas/record',
                    component: resolve => require(['../components/env/gas_record.vue'], resolve),
                    meta: {
                        title: '报警记录(毒害气体数据)'
                    }
                },
                {
                    path: 'env/gas/setting',
                    component: resolve => require(['../components/env/gas_setting.vue'], resolve),
                    meta: {
                        title: '报警设置(毒害气体数据)'
                    }
                },
            ]
        },
        //设备管理
        {
            path: '/',
            component: resolve => require(['../components/mach/header.vue'], resolve),
            meta: {
                title: '设备管理'
            },
            children: [{
                path: 'mach/index',
                component: resolve => require(['../components/mach/index.vue'], resolve),
                meta: {
                    title: '数据分析'
                }
            },
                {
                    path: 'mach/ana',
                    component: resolve => require(['../components/mach/ana.vue'], resolve),
                    meta: {
                        title: '数据分析'
                    }
                },
                {
                    path: 'mach/dev',
                    component: resolve => require(['../components/mach/dev.vue'], resolve),
                    meta: {
                        title: '设备硬件'
                    }
                },
                {
                    path: 'mach/list',
                    component: resolve => require(['../components/mach/list.vue'], resolve),
                    meta: {
                        title: '设备信息'
                    }
                },
                {
                    path: 'mach/data',
                    component: resolve => require(['../components/mach/data.vue'], resolve),
                    meta: {
                        title: '设备数据'
                    }
                },
                {
                    path: 'mach/warn/setting',
                    component: resolve => require(['../components/mach/warn_setting.vue'], resolve),
                    meta: {
                        title: '报警设置'
                    }
                },
                {
                    path: 'mach/warn/record',
                    component: resolve => require(['../components/mach/warn_record.vue'], resolve),
                    meta: {
                        title: '报警记录'
                    }
                },
                {
                    path: 'mach/day-report',
                    component: resolve => require(['../components/mach/dayReport.vue'], resolve),
                    meta: {
                        title: '设备日报'
                    }
                },
                {
                    path: 'mach/week-report',
                    component: resolve => require(['../components/mach/weekReport.vue'], resolve),
                    meta: {
                        title: '设备周报'
                    }
                },
                {
                    path: 'mach/machMulti',
                    component: resolve => require(['../components/mach/machMulti.vue'], resolve),
                    meta: {
                        title: '设备维度分析'
                    }
                },
                {
                    path: 'mach/month-report',
                    component: resolve => require(['../components/mach/monthReport.vue'], resolve),
                    meta: {
                        title: '设备月报'
                    }
                },
                {
                    path: 'mach/report-center',
                    component: resolve => require(['../components/mach/reportAll.vue'], resolve),
                    meta: {
                        title: '报表中心'
                    }
                },
                {
                    path: 'mach/maintain/record',
                    component: resolve => require(['../components/mach/maintain_record.vue'], resolve),
                    meta: {
                        title: '报表中心'
                    }
                },
                {
                    path: 'mach/maintain/report',
                    component: resolve => require(['../components/mach/maintain_report.vue'], resolve),
                    meta: {
                        title: '保养报表'
                    }
                },
                {
                    path: 'mach/dict',
                    component: resolve => require(['../components/mach/dict.vue'], resolve),
                    meta: {
                        title: '保养报表'
                    }
                },
            ]
        },
        //视频管理
        {
            path: '/',
            component: resolve => require(['../components/fvs/header.vue'], resolve),
            meta: {
                title: '视频管理'
            },
            children: [{
                path: 'fvs/device',
                component: resolve => require(['../components/fvs/device.vue'], resolve),
                meta: {
                    title: '视频设备'
                }
            },
                {
                    path: 'fvs/record',
                    component: resolve => require(['../components/fvs/record.vue'], resolve),
                    meta: {
                        title: '视频监控'
                    }
                },
                {
                    path: 'fvs/log',
                    component: resolve => require(['../components/fvs/log.vue'], resolve),
                    meta: {
                        title: '抓拍记录'
                    }
                },
                {
                    path: 'fvs/ana',
                    component: resolve => require(['../components/fvs/ana.vue'], resolve),
                    meta: {
                        title: '智能监控分析'
                    }
                },
                // {
                //     path: 'fim/emp',
                //     component: resolve => require(['../components/fim/emp.vue'], resolve),
                //     meta: {
                //         title: '人员管理'
                //     }
                // },
                {
                    path: 'fvs/warn/record',
                    component: resolve => require(['../components/fvs/warn_record.vue'], resolve),
                    meta: {
                        title: '报警记录'
                    }
                },
                {
                    path: 'fvs/warn/setting',
                    component: resolve => require(['../components/fvs/warn_setting.vue'], resolve),
                    meta: {
                        title: '报警设置'
                    }
                },
                {
                    path: 'fvs/warn/loudspeaker',
                    component: resolve => require(['../components/fvs/loudspeaker.vue'], resolve),
                    meta: {
                        title: '绑定云音箱'
                    }
                }
            ]
        },
        //内部应用
        {
            path: '/',
            component: resolve => require(['../components/inner/header.vue'], resolve),
            meta: {
                title: '内部应用'
            },
            children: [{
                path: 'inner/news',
                component: resolve => require(['../components/inner/newsConfig.vue'], resolve),
                meta: {
                    title: '官网内容管理'
                }
            },
                {
                    path: 'inner/cfg',
                    component: resolve => require(['../components/inner/cfg.vue'], resolve),
                    meta: {
                        title: '配置中心'
                    }
                },
                {
                    path: 'inner/openapi',
                    component: resolve => require(['../components/inner/openapi.vue'], resolve),
                    meta: {
                        title: '开放接口'
                    }
                },
                {
                    path: 'inner/sgitg',
                    component: resolve => require(['../components/inner/sgitg.vue'], resolve),
                    meta: {
                        title: '国网信通'
                    }
                },
            ]
        },
        //车辆管理
        {
            path: '/',
            component: resolve => require(['../components/car/header.vue'], resolve),
            meta: {
                title: '车辆管理'
            },
            children: [{
                path: 'car/gate',
                component: resolve => require(['../components/car/gate.vue'], resolve),
                meta: {
                    title: '车辆识别'
                }
            },]
        },
        //物质管理
        {
            path: '/',
            component: resolve => require(['../components/fmam/header.vue'], resolve),
            meta: {
                title: '物资管理'
            },
            children: [{
                path: 'fmam/weighRoom',
                component: resolve => require(['../components/fmam/weighRoom.vue'], resolve),
                meta: {
                    title: '磅房管理'
                }
            },
                {
                    path: 'fmam/warehouse',
                    component: resolve => require(['../components/fmam/warehouse.vue'], resolve),
                    meta: {
                        title: '仓库管理'
                    }
                },
                {
                    path: 'fmam/corp',
                    component: resolve => require(['../components/fmam/corp.vue'], resolve),
                    meta: {
                        title: '物资合作单位'
                    }
                },
                {
                    path: 'fmam/mat',
                    component: resolve => require(['../components/fmam/mat.vue'], resolve),
                    meta: {
                        title: '材料字典'
                    }
                },
                {
                    path: 'fmam/receiveNote',
                    component: resolve => require(['../components/fmam/receiveNote.vue'], resolve),
                    meta: {
                        title: '收料台账'
                    }
                },
                {
                    path: 'fmam/sendNote',
                    component: resolve => require(['../components/fmam/sendNote.vue'], resolve),
                    meta: {
                        title: '发料台账'
                    }
                },
                {
                    path: 'fmam/supplierDetail',
                    component: resolve => require(['../components/fmam/supplierDetail.vue'], resolve),
                    meta: {
                        title: '供应商供货明细'
                    }
                },
                {
                    path: 'fmam/receive',
                    component: resolve => require(['../components/fmam/receive.vue'], resolve),
                    meta: {
                        title: '收料汇总分析'
                    }
                },
                {
                    path: 'fmam/send',
                    component: resolve => require(['../components/fmam/send.vue'], resolve),
                    meta: {
                        title: '发料汇总分析'
                    }
                },
                {
                    path: 'fmam/supplierDiff',
                    component: resolve => require(['../components/fmam/supplierDiff.vue'], resolve),
                    meta: {
                        title: '供应商供货偏差分析'
                    }
                },
                {
                    path: 'fmam/receiveDetailes',
                    component: resolve => require(['../components/fmam/receiveDetailes.vue'], resolve),
                    meta: {
                        title: '收料明细'
                    }
                },
                {
                    path: 'fmam/sendDetailes',
                    component: resolve => require(['../components/fmam/sendDetailes.vue'], resolve),
                    meta: {
                        title: '发料明细'
                    }
                },
                {
                    path: 'fmam/supplierDetailes',
                    component: resolve => require(['../components/fmam/supplierDetailes.vue'], resolve),
                    meta: {
                        title: '供应商明细'
                    }
                },
                {
                    path: 'fmam/plan',
                    component: resolve => require(['../components/fmam/plan.vue'], resolve),
                    meta: {
                        title: '材料计划'
                    }
                },
                {
                    path: 'fmam/plan/add',
                    component: resolve => require(['../components/fmam/planAdd.vue'], resolve),
                    meta: {
                        title: '材料计划添加'
                    }
                },
                {
                    path: 'fmam/plan/details',
                    component: resolve => require(['../components/fmam/planDetails.vue'], resolve),
                    meta: {
                        title: '材料计划添加'
                    }
                },
            ]
        },
        //人员管理
        {
            path: '/',
            component: resolve => require(['../components/emp/header.vue'], resolve),
            meta: {
                title: '人员管理'
            },
            children: [{
                path: 'emp/index',
                component: resolve => require(['../components/emp/index.vue'], resolve),
                meta: {
                    title: '首页'
                }
            },
                {
                    path: 'emp/list',
                    component: resolve => require(['../components/emp/list.vue'], resolve),
                    meta: {
                        title: '人员信息'
                    }
                },
                {
                    path: 'emp/ana',
                    component: resolve => require(['../components/emp/ana.vue'], resolve),
                    meta: {
                        title: '人员分析'
                    }
                }, {
                    path: 'emp/approve',
                    component: resolve => require(['../components/emp/approve.vue'], resolve),
                    meta: {title: '人员审批'}
                },
                {
                    path: 'emp/group',
                    component: resolve => require(['../components/emp/group.vue'], resolve),
                    meta: {
                        title: '班组管理'
                    }
                },

                {
                    path: 'emp/reward',
                    component: resolve => require(['../components/emp/reward.vue'], resolve),
                    meta: {
                        title: '奖惩记录'
                    }
                },
                {
                    path: 'emp/payroll',
                    component: resolve => require(['../components/emp/payroll.vue'], resolve),
                    meta: {
                        title: '劳资管理'
                    }
                },
                {
                    path: 'emp/card',
                    component: resolve => require(['../components/emp/card.vue'], resolve),
                    meta: {
                        title: '打卡记录'
                    }
                },
                {
                    path: 'emp/visitor',
                    component: resolve => require(['../components/emp/visitor.vue'], resolve),
                    meta: {
                        title: '访客记录'
                    }
                },
                {
                    path: 'emp/broadcast',
                    component: resolve => require(['../components/emp/broadcast.vue'], resolve),
                    meta: {
                        title: '人员广播'
                    }
                },
                {
                    path: 'emp/train',
                    component: resolve => require(['../components/emp/train.vue'], resolve),
                    meta: {
                        title: '人员培训'
                    }
                },
                {
                    path: 'emp/education',
                    component: resolve => require(['../components/emp/education.vue'], resolve),
                    meta: {
                        title: '教育箱'
                    }
                },
                {
                    path: 'emp/gate',
                    component: resolve => require(['../components/emp/gate.vue'], resolve),
                    meta: {
                        title: '刷脸记录'
                    }
                },
                {
                    path: 'emp/attend',
                    component: resolve => require(['../components/emp/attend.vue'], resolve),
                    meta: {
                        title: '考勤信息'
                    }
                },
                {
                    path: 'emp/faceGate',
                    component: resolve => require(['../components/emp/faceGate.vue'], resolve),
                    meta: {
                        title: '闸机管理'
                    }
                },
                {
                    path: 'emp/trainee',
                    component: resolve => require(['../components/emp/trainee.vue'], resolve),
                    meta: {
                        title: '培训详情'
                    }
                },
                {
                    path: 'emp/payroll_details',
                    component: resolve => require(['../components/emp/payroll_details.vue'], resolve),
                    meta: {
                        title: '劳资详情'
                    }
                },
                {
                    path: 'emp/fence',
                    component: resolve => require(['../components/emp/fence.vue'], resolve),
                    meta: {
                        title: '电子围栏'
                    }
                },
                {
                    path: 'emp/setting',
                    component: resolve => require(['../components/emp/setting.vue'], resolve),
                    meta: {
                        title: '人员设置'
                    }
                },
                {
                    path: 'emp/data',
                    component: resolve => require(['../components/emp/data.vue'], resolve),
                    meta: {
                        title: '人员日报'
                    }
                },
                {
                    path: 'emp/warn/record',
                    component: resolve => require(['../components/emp/warn_record.vue'], resolve),
                    meta: {
                        title: '报警记录'
                    }
                },
                {
                    path: 'emp/warn/setting',
                    component: resolve => require(['../components/emp/warn_setting.vue'], resolve),
                    meta: {
                        title: '报警设置'
                    }
                },
                {
                    path: 'emp/blacklist',
                    component: resolve => require(['../components/emp/blacklist.vue'], resolve),
                    meta: {
                        title: '黑名单管理'
                    }
                },
                {
                    path: 'emp/gps',
                    component: resolve => require(['../components/emp/gps.vue'], resolve),
                    meta: {
                        title: '人员轨迹'
                    }
                },
                {
                    path: 'emp/workType',
                    component: resolve => require(['../components/emp/workType.vue'], resolve),
                    meta: {
                        title: '工种字典'
                    }
                },
                {
                    path: 'emp/audit',
                    component: resolve => require(['../components/emp/audit.vue'], resolve),
                    meta: {
                        title: '访客审批'
                    }
                },

            ]
        },
        // 旋挖设备
        {
            path: '/',
            component: resolve => require(['../components/rotary/header.vue'], resolve),
            meta: {
                title: '旋挖设备'
            },
            children: [{
                path: 'rotary/index',
                component: resolve => require(['../components/rotary/index.vue'], resolve),
                meta: {
                    title: '设备信息'
                }
            },
                {
                    path: 'rotary/list',
                    component: resolve => require(['../components/rotary/list.vue'], resolve),
                    meta: {
                        title: '设备信息'
                    }
                },
                {
                    path: 'rotary/emp',
                    component: resolve => require(['../components/rotary/emp.vue'], resolve),
                    meta: {
                        title: '人员信息'
                    }
                },
                {
                    path: 'rotary/gps',
                    component: resolve => require(['../components/rotary/gps.vue'], resolve),
                    meta: {
                        title: '轨迹回放'
                    }
                },
                {
                    path: 'rotary/upkeep',
                    component: resolve => require(['../components/rotary/upkeep.vue'], resolve),
                    meta: {
                        title: '设备保养'
                    }
                },

                {
                    path: 'rotary/ana',
                    component: resolve => require(['../components/rotary/ana.vue'], resolve),
                    meta: {
                        title: '驾驶行为分析'
                    }
                },
                {
                    path: 'rotary/warn/record',
                    component: resolve => require(['../components/rotary/warn_record.vue'], resolve),
                    meta: {
                        title: '报警记录'
                    }
                },
                {
                    path: 'rotary/warn/setting',
                    component: resolve => require(['../components/rotary/warn_setting.vue'], resolve),
                    meta: {
                        title: '报警设置'
                    }
                }
            ]
        },
        // 考勤设备
        {
            path: '/',
            component: resolve => require(['../components/equip/header.vue'], resolve),
            meta: {
                title: '考勤设备'
            },
            children: [{
                path: 'equip/index',
                component: resolve => require(['../components/equip/index.vue'], resolve),
                meta: {
                    title: '首页'
                }
            },
                {
                    path: 'equip/no_data',
                    component: resolve => require(['../components/equip/no_data.vue'], resolve),
                    meta: {
                        title: '暂无数据'
                    }
                },
                {
                    path: 'equip/atternAna',
                    component: resolve => require(['../components/equip/enterpriseAna.vue'], resolve),
                    meta: {
                        title: '出勤分析'
                    }
                },
                {
                    path: 'equip/list',
                    component: resolve => require(['../components/equip/list.vue'], resolve),
                    meta: {
                        title: '设备信息'
                    }
                },
                {
                    path: 'equip/device',
                    component: resolve => require(['../components/equip/device.vue'], resolve),
                    meta: {
                        title: '设备考勤'
                    }
                },
                {
                    path: 'equip/dayReport',
                    component: resolve => require(['../components/equip/dayReport.vue'], resolve),
                    meta: {
                        title: '设备日报'
                    }
                },
                {
                    path: 'equip/fence',
                    component: resolve => require(['../components/equip/fence.vue'], resolve),
                    meta: {
                        title: '电子围栏'
                    }
                },
                {
                    path: 'equip/warn/record',
                    component: resolve => require(['../components/equip/warn_record.vue'], resolve),
                    meta: {
                        title: '报警记录'
                    }
                },
                {
                    path: 'equip/warn/setting',
                    component: resolve => require(['../components/equip/warn_setting.vue'], resolve),
                    meta: {
                        title: '报警设置'
                    }
                },
                {
                    path: 'equip/gps',
                    component: resolve => require(['../components/equip/gps.vue'], resolve),
                    meta: {
                        title: '设备轨迹'
                    }
                },
                {
                    path: 'equip/statement',
                    component: resolve => require(['../components/equip/statement.vue'], resolve),
                    meta: {
                        title: '考勤报表'
                    }
                },
                {
                    path: 'equip/ana',
                    component: resolve => require(['../components/equip/enterpriseAna.vue'], resolve),
                    meta: {
                        title: '考勤企业级出勤分析统计'
                    }
                },
                {
                    path: 'equip/anaDetail',
                    component: resolve => require(['../components/equip/enterpriseAnaDetail.vue'], resolve),
                    meta: {
                        title: '考勤企业级出勤分析详情'
                    }
                },
                {
                    path: 'equip/warnRecordDetails',
                    component: resolve => require(['../components/equip/enterpriseWarnRecordDetails.vue'], resolve),
                    meta: {
                        title: '考勤企业级项目预警详情'
                    }
                },

            ]
        },
        //特种设备
        {
            path: '/fse/',
            component: resolve => require(['../components/fse/header.vue'], resolve),
            meta: {
                title: '特种设备管理'
            },
            children: [
                /**
                 *  塔机
                 * */
                {
                    path: 'crane/msg',
                    component: resolve => require(['../components/fse/crane.vue'], resolve),
                    meta: {
                        title: '塔机管理'
                    }
                },
                {
                    path: 'crane/monitor',
                    component: resolve => require(['../components/fse/crane_monitor.vue'], resolve),
                    meta: {
                        title: '塔机监控'
                    }
                },
                {
                    path: 'crane/record',
                    component: resolve => require(['../components/fse/crane_record.vue'], resolve),
                    meta: {
                        title: '吊装记录'
                    }
                },
                {
                    path: 'crane/warn/record',
                    component: resolve => require(['../components/fse/craneWarnRecord.vue'], resolve),
                    meta: {
                        title: '报警记录'
                    }
                },
                {
                    path: 'crane/warn/setting',
                    component: resolve => require(['../components/fse/craneWarnSetting.vue'], resolve),
                    meta: {
                        title: '报警设置'
                    }
                },
                {
                    path: 'crane/rigging',
                    component: resolve => require(['../components/fse/rigging.vue'], resolve),
                    meta: {
                        title: '吊索具信息'
                    }
                },
                /**
                 * 升降机
                 * */
                {
                    path: 'lift/msg',
                    component: resolve => require(['../components/fse/lift.vue'], resolve),
                    meta: {
                        title: '升降机管理'
                    }
                },
                {
                    path: 'lift/monitor',
                    component: resolve => require(['../components/fse/lift_monitor.vue'], resolve),
                    meta: {
                        title: '升降机监控'
                    }
                },
                {
                    path: 'lift/record',
                    component: resolve => require(['../components/fse/lift_record.vue'], resolve),
                    meta: {
                        title: '升降机记录'
                    }
                },
                {
                    path: 'lift/warn/record',
                    component: resolve => require(['../components/fse/liftWarnRecord.vue'], resolve),
                    meta: {
                        title: '报警记录'
                    }
                },
                {
                    path: 'lift/warn/setting',
                    component: resolve => require(['../components/fse/liftWarnSetting.vue'], resolve),
                    meta: {
                        title: '报警设置'
                    }
                },
                /**
                 * 龙门吊
                 * */
                {
                    path: 'gantry/msg',
                    component: resolve => require(['../components/fse/gantry.vue'], resolve),
                    meta: {
                        title: '龙门吊管理'
                    }
                },
                {
                    path: 'gantry/monitor',
                    component: resolve => require(['../components/fse/gantry_monitor.vue'], resolve),
                    meta: {
                        title: '龙门吊监控'
                    }
                },
                {
                    path: 'gantry/warn/record',
                    component: resolve => require(['../components/fse/gantryWarnRecord.vue'], resolve),
                    meta: {
                        title: '报警记录'
                    }
                },
                {
                    path: 'gantry/warn/setting',
                    component: resolve => require(['../components/fse/gantryWarnSetting.vue'], resolve),
                    meta: {
                        title: '报警设置'
                    }
                },
                /**
                 * 架桥机
                 * */
                {
                    path: 'bridge/msg',
                    component: resolve => require(['../components/fse/bridge.vue'], resolve),
                    meta: {
                        title: '架桥机管理'
                    }
                },
                {
                    path: 'bridge/monitor',
                    component: resolve => require(['../components/fse/bridge_monitor.vue'], resolve),
                    meta: {
                        title: '架桥机监控'
                    }
                },
                {
                    path: 'bridge/warn/record',
                    component: resolve => require(['../components/fse/bridgeWarnRecord.vue'], resolve),
                    meta: {
                        title: '报警记录'
                    }
                },
                {
                    path: 'bridge/warn/setting',
                    component: resolve => require(['../components/fse/bridgeWarnSetting.vue'], resolve),
                    meta: {
                        title: '报警设置'
                    }
                },
                /**
                 * 履带吊
                 * */
                {
                    path: 'crawler/msg',
                    component: resolve => require(['../components/fse/crawler/crawler_msg.vue'], resolve),
                    meta: {
                        title: '设备信息'
                    }
                },
                {
                    path: 'crawler/monitor',
                    component: resolve => require(['../components/fse/crawler/crawler_monitor.vue'], resolve),
                    meta: {
                        title: '设备监控'
                    }
                },
                {
                    path: 'crawler/warn/record',
                    component: resolve => require(['../components/fse/crawler/crawler_Warn.vue'], resolve),
                    meta: {
                        title: '报警记录'
                    }
                },
                {
                    path: 'crawler/warn/setting',
                    component: resolve => require(['../components/fse/crawler/crawler_WarnSetting.vue'], resolve),
                    meta: {
                        title: '报警设置'
                    }
                },
            ]
        },
        //隧道管理
        {
            path: '/',
            component: resolve => require(['../components/tunnel/header.vue'], resolve),
            meta: {
                title: '隧道管理'
            },
            children: [
                {
                    path: '/tunnel/data',
                    component: resolve => require(['../components/tunnel/data.vue'], resolve),
                    meta: {
                        title: '数据监测'
                    }
                },
            ]
        },
        //能耗管理
        {
            path: '/',
            component: resolve => require(['../components/energy/header.vue'], resolve),
            meta: {
                title: '能耗管理'
            },
            children: [
                {
                    path: 'energy/water',
                    component: resolve => require(['../components/energy/water.vue'], resolve),
                    meta: {
                        title: '智能水表'
                    }
                },
                {
                    path: 'energy/ammeter',
                    component: resolve => require(['../components/energy/ammeter.vue'], resolve),
                    meta: {
                        title: '智能电表'
                    }
                },
                {
                    path: 'energy/electric',
                    component: resolve => require(['../components/energy/electric.vue'], resolve),
                    meta: {
                        title: '智能电箱'
                    }
                },
            ]
        },
        //硬件中心
        {
            path: '/',
            component: resolve => require(['../components/hardware/header.vue'], resolve),
            meta: {
                title: '硬件中心'
            },
            children: [
                {
                    path: 'hdc/dev',
                    component: resolve => require(['../components/hardware/dev.vue'], resolve),
                    meta: {
                        title: '机械云管家'
                    }
                },
                {
                    path: 'hdc/dev_data',
                    component: resolve => require(['../components/hardware/dev_data.vue'], resolve),
                    meta: {
                        title: '机械云管家数据'
                    }
                },
                {
                    path: 'hdc/helmet',
                    component: resolve => require(['../components/hardware/helmet.vue'], resolve),
                    meta: {
                        title: '定位安全帽'
                    }
                },
                {
                    path: 'hdc/helmet_data',
                    component: resolve => require(['../components/hardware/helmet_data.vue'], resolve),
                    meta: {
                        title: '定位安全帽硬件数据'
                    }
                },
                {
                    path: 'hdc/equip',
                    component: resolve => require(['../components/hardware/equip.vue'], resolve),
                    meta: {
                        title: '考勤设备'
                    }
                },
                {
                    path: 'hdc/equip_data',
                    component: resolve => require(['../components/hardware/equip_data.vue'], resolve),
                    meta: {
                        title: '考勤设备硬件数据'
                    }
                },
                {
                    path: 'hdc/obd',
                    component: resolve => require(['../components/hardware/obd.vue'], resolve),
                    meta: {
                        title: 'OBD硬件'
                    }
                },
                {
                    path: 'hdc/obd_data',
                    component: resolve => require(['../components/hardware/obd_data.vue'], resolve),
                    meta: {
                        title: 'OBD硬件数据'
                    }
                },
                {
                    path: 'hdc/fvs',
                    component: resolve => require(['../components/hardware/fvs.vue'], resolve),
                    meta: {
                        title: '视频安全帽'
                    }
                },
                {
                    path: 'hdc/fvs_data',
                    component: resolve => require(['../components/hardware/fvs_data.vue'], resolve),
                    meta: {
                        title: '视频安全帽硬件数据'
                    }
                },
                {
                    path: 'hdc/alg',
                    component: resolve => require(['../components/hardware/alg.vue'], resolve),
                    meta: {
                        title: '算法盒子'
                    }
                },
                {
                    path: 'hdc/alg_data',
                    component: resolve => require(['../components/hardware/alg_data.vue'], resolve),
                    meta: {
                        title: '算法盒子硬件数据'
                    }
                },
                {
                    path: 'hdc/alg_config',
                    component: resolve => require(['../components/hardware/alg_config.vue'], resolve),
                    meta: {
                        title: '算法盒子配置'
                    }
                },
                {
                    path: 'hdc/upgrade',
                    component: resolve => require(['../components/hardware/upgrade.vue'], resolve),
                    meta: {
                        title: '硬件升级'
                    }
                },
                {
                    path: 'hdc/platform',
                    component: resolve =>require(['../components/hardware/platform.vue'], resolve),
                    meta: {
                        title: '第三方硬件'
                    }
                },
            ]
        },
        //管网管理
        {
            path: '/',
            component: resolve => require(['../components/pipe/header.vue'], resolve),
            meta: {
                title: '管网管理'
            },
            children: [
                {
                    path: 'pipe/rain',
                    component: resolve => require(['../components/pipe/rain.vue'], resolve),
                    meta: {
                        title: '雨水管理'
                    }
                },
                {
                    path: 'pipe/sewage',
                    component: resolve => require(['../components/pipe/sewage.vue'], resolve),
                    meta: {
                        title: '污水管理'
                    }
                },
            ]
        },
        //内部位移监测
        {
            path: '/',
            component: resolve => require(['../components/dispment/header.vue'], resolve),
            meta: {
                title: '内部位移监测'
            },
            children: [
                {
                    path: '/dispment/data',
                    component: resolve => require(['../components/dispment/data.vue'], resolve),
                    meta: {
                        title: '数据监测'
                    }
                },
            ]
        },
        //全景看板
        {
            path: '/',
            component: resolve => require(['../components/panorama/header.vue'], resolve),
            meta: {
                title: '全景看板'
            },
            children: [
                {
                    path: 'panorama/index',
                    component: resolve => require(['../components/panorama/index.vue'], resolve),
                    meta: {
                        title: '全景看板'
                    }
                },
                {
                    path: 'board/720',
                    component: resolve => require(['../components/panorama/index.vue'], resolve),
                    meta: {
                        title: '全景看板'
                    }
                },
            ]
        },
        //米多智慧工地-数据看板
        {
            path: '/',
            component: resolve => require(['../components/md-board/boardTab.vue'], resolve),
            meta: {
                title: '米多智慧工地-数据看板'
            },
            children:[
                {
                    path: '/md-board/index',
                    component: resolve => require(['../components/md-board/index.vue'], resolve),
                    meta: {
                        title: '首页'
                    }
                },
                {
                    path: '/md-board/emp',
                    component: resolve => require(['../components/md-board/emp.vue'], resolve),
                    meta: {
                        title: '人员管理'
                    }
                },
                {
                    path: '/md-board/device',
                    component: resolve => require(['../components/md-board/device.vue'], resolve),
                    meta: {
                        title: '设备管理'
                    }
                },
                {
                    path: '/md-board/safety',
                    component: resolve => require(['../components/md-board/safety.vue'], resolve),
                    meta: {
                        title: '安全管理'
                    }
                },
                {
                    path: '/md-board/quality',
                    component: resolve => require(['../components/md-board/quality.vue'], resolve),
                    meta: {
                        title: '质量管理'
                    }
                },
                {
                    path: '/md-board/video-monitoring',
                    component: resolve => require(['../components/md-board/video-monitoring.vue'], resolve),
                    meta: {
                        title: '视频监控'
                    }
                },
                {
                    path: '/md-board/env-monitoring',
                    component: resolve => require(['../components/md-board/env-monitoring.vue'], resolve),
                    meta: {
                        title: '环境监控'
                    }
                },
                {
                    path: '/md-board/material',
                    component: resolve => require(['../components/md-board/material.vue'], resolve),
                    meta: {
                        title: '物料管理'
                    }
                },
                {
                    path: '/md-board/construction',
                    component: resolve => require(['../components/md-board/construction.vue'], resolve),
                    meta: {
                        title: '党的建设'
                    }
                },
                {
                    path: '/md-board/electricity',
                    component: resolve => require(['../components/md-board/electricity.vue'], resolve),
                    meta: {
                        title: '用电监测'
                    }
                },
                {
                    path: '/md-board/algorithm',
                    component: resolve => require(['../components/md-board/algorithm.vue'], resolve),
                    meta: {
                        title: '算法监控'
                    }
                },
                {
                    path: '/md-board/md-crane',
                    component: resolve => require(['../components/md-board/md-crane.vue'], resolve),
                    meta: {
                        title: '塔吊监控'
                    }
                },
                {
                    path: '/md-board/md-gantry',
                    component: resolve => require(['../components/md-board/md-gantry.vue'], resolve),
                    meta: {
                        title: '龙门吊监控'
                    }
                },
                {
                    path: '/md-board/gas',
                    component: resolve => require(['../components/md-board/gas.vue'], resolve),
                    meta: {
                        title: '气体监控'
                    }
                }
            ]
        },
        //数据监测
        {
            path: '/',
            component: resolve => require(['../components/dataMon/header.vue'], resolve),
            meta: {
                title: '数据监测'
            },
            children: [
                {
                    path: '/dataMon/deep',
                    component: resolve => require(['../components/dataMon/deep.vue'], resolve),
                    meta: {
                        title: '基坑监测'
                    }
                },
                {
                    path: '/dataMon/highmode',
                    component: resolve => require(['../components/dataMon/highmode.vue'], resolve),
                    meta: {
                        title: '高支模监测'
                    }
                },
            ]
        },
        {
            path: '/',
            component: resolve => require(['../components/work/header.vue'], resolve),
            meta: {
                title: '工作督办'
            },
            children: [
                {
                    path: '/work/approval',
                    component: resolve => require(['../components/work/approval.vue'], resolve),
                    meta: {
                        title: '文档审批'
                    }
                },
                {
                    path: 'work/components/add',
                    component: resolve => require(['../components/work/components/add.vue'], resolve),
                    meta: {
                        title: '添加'
                    }
                },
                {
                    path: 'work/components/edit',
                    component: resolve => require(['../components/work/components/edit.vue'], resolve),
                    meta: {
                        title: '编辑'
                    }
                },
            ]
        },
        {
            path: '/',
            component: resolve => require(['../components/party/header.vue'], resolve),
            meta: {
                title: '党建管理'
            },
            children: [
                {
                    path: '/party/act',
                    component: resolve => require(['../components/party/act.vue'], resolve),
                    meta: {
                        title: '党员活动'
                    }
                },
                {
                    path: '/party/msg',
                    component: resolve => require(['../components/party/msg.vue'], resolve),
                    meta: {
                        title: '党员信息'
                    }
                },
            ]
        },
        //BIM管理
        {
            path: '/',
            component: resolve => require(['../components/bim/header.vue'], resolve),
            meta: {
                title: 'BIM管理'
            },
            children: [
                {
                    path: '/bim/index',
                    component: resolve => require(['../components/bim/index.vue'], resolve),
                    meta: {
                        title: 'BIM模型'
                    }
                },
            ]
        },
        //盾构管理
        {
            path: '/',
            component: resolve => require(['../components/dggl/header.vue'], resolve),
            meta: {
                title: '盾构管理'
            },
            children: [
                {
                    path: 'dggl/new_knifelist',
                    component: resolve => require(['../components/dggl/new_knifelist.vue'], resolve),
                    meta: {
                        title: '新刀具管理'
                    }
                },
                {
                    path: 'dggl/routine_inspection',
                    component: resolve => require(['../components/dggl/routine_inspection.vue'], resolve),
                    meta: {
                        title: '盾构刀片日常管理'
                    }
                },
                {
                    path: 'dggl/list',
                    component: resolve => require(['../components/dggl/list.vue'], resolve),
                    meta: {
                        title: '盾构管理'
                    }
                },
                {
                    path: 'dggl/knifebox',
                    component: resolve => require(['../components/dggl/knifebox.vue'], resolve),
                    meta: {
                        title: '盾构日常管理刀箱号查询'
                    }
                },
                {
                    path: 'dggl/knifesn',
                    component: resolve => require(['../components/dggl/knifesn.vue'], resolve),
                    meta: {
                        title: '盾构日常管理刀轴号查询'
                    }
                },
                {
                    path: 'dggl/old',
                    component: resolve => require(['../components/dggl/old.vue'], resolve),
                    meta: {
                        title: '旧刀查询表'
                    }
                },
                {
                    path: 'dggl/discard/list',
                    component: resolve => require(['../components/dggl/scrap.vue'], resolve),
                    meta: {
                        title: '报废刀查询表'
                    }
                },
            ]
        },
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js